import { useEffect, useMemo, useState } from "react"
import { AdminTrack, TrendTrack } from "../../../../types"
import { TrackPerformanceDetails, TrackPerformanceTableRow } from "./TrackPerformance"
import trackPerformanceTableColumns from "./table-columns/trackPerformanceTableColumns"
import TableNew from "../../../ui/table/TableNew"
import { KTitleSpan } from "kahuna-base-react-components"
import PlatformPerformance from "../platform-performance/PlatformPerformance"
import { lang } from "../../../../constants/languages"

const TrackPerformanceTable = ({
  trendTrackList,
  pageNumber,
  setPageNumber,
  count,
  limit,
  eventType,
  selectedCountries
}: {
  trendTrackList: TrackPerformanceDetails[]
  pageNumber: number
  setPageNumber: (pageNumber: number) => void
  count: number
  limit: number
  eventType: string,
  selectedCountries: string[]
}) => {
  const [trendTrackTableData, setTrendTrackTableData] = useState<TrackPerformanceDetails[]>([])

  const onClickPage = (pageNumber: number) => {
    setPageNumber(pageNumber)
  }

  const growthRate = (row: TrackPerformanceTableRow) => {
    const prev = row.prevWeekTotalStreams ?? 0
    const curr = row.totalStreams ?? 0

    // If prev is 0:
    // - if curr is also 0 => treat as 0 growth
    // - if curr > 0 => treat as "infinite" growth, push to top
    if (prev === 0) return curr === 0 ? 0 : Number.POSITIVE_INFINITY

    return (curr - prev) / prev
  }

  useEffect(() => {
    if (!trendTrackList?.length) {
      setTrendTrackTableData([])
      return
    }

    //const rows = Array.from(map.values()).sort((a, b) => growthRate(b) - growthRate(a))
    const sortKey = eventType === "social" ? "socialConsumption" : eventType
    //@ts-ignore
    const rows = trendTrackList.sort((a, b) => b.selectedWeek?.[sortKey] - a.selectedWeek?.[sortKey])

    setTrendTrackTableData(rows)
  }, [trendTrackList, eventType])

  const trackPerformanceColumns = useMemo(() => {
    return trackPerformanceTableColumns(eventType, selectedCountries.length)
  }, [eventType, selectedCountries])

  return (
    <div className="w-full">
      <TableNew
        title={<KTitleSpan text={lang.analytics.track_performance.title} fontSize={20} lineHeight="24px" />}
        columns={trackPerformanceColumns}
        data={trendTrackTableData}
        count={count}
        limit={limit}
        onClickPage={onClickPage}
        pagination
        pageNumber={pageNumber}
        minRowCount={10}
        notFoundTitle={lang.not_found.trends.title}
        notFoundDesc={lang.not_found.trends.desc}
      />
    </div>
  )
}

export default TrackPerformanceTable
